export const reportConfiguratorMainFields = [
    'templateName',
    'templateCode',
    'reportName',
    'designTemplate',
    'paginationPosition',
    'enabledMenu',
    'withDocumentId',
    'enabledComparisonBtn',
    'enabledCrBtn',
    'enabledColumnsSettingsBtn',
    'enabledRefreshBtn',
    'enabledSearch',
    'enabledDownloadBtn',
    'enabledGroupingSettingsBtn',
    'enabledSelectAllRowsBtn',
    'actionsEnabled',
    'tableDatasourceType',
    'enabledRowComments',
    'enabledRowAttachments',
    'enabledAttachmentsBtn',
    'enabledRowRequests',
    'enabledComparison',
    'enabledCr',
    'enabledViewControlRatioBtn',
    'enabledColumnTitleOrdinals',
    'enabledPrint',
    'enabledDrillUpBtn',
    'enabledEnabledPreExecution',
    'enabledDetailedSummaryBtn',
    'enabledMenuWhenUsingDrillFilter',
    'enabledRecordsInfo',
    'tableDatasourceSqlValue',
    'tableDatasourceValue',
    'headerDatasourceType',
    'headerDatasourceSqlValue',
    'headerDatasourceValue',
] as const;
export type TReportConfiguratorMainFields = (typeof reportConfiguratorMainFields)[number];

export const reportConfiguratorReservedColumnsField = 'reservedColumns' as const;
export type TReportConfiguratorReservedColumnsFields = typeof reportConfiguratorReservedColumnsField;

export const reportConfiguratorDownloadSettingsField = 'downloadSettings' as const;
export type TReportConfiguratorDownloadSettingsField = typeof reportConfiguratorDownloadSettingsField
